import { Shield, Briefcase, Users } from 'lucide-react';

export default function LockerDetails() {
    return (
        <div className="p-8 pb-10 space-y-6 text-primary-dark bg-card-background rounded-xl shadow-2xl border border-accent-main/30 font-sans h-full">
            <h3 className="text-3xl font-extrabold text-accent-main border-b-2 border-accent-main pb-3 mb-4">Protect What Matters Most</h3>
            <p className="text-lg leading-relaxed">
                <b className="text-primary-dark">Eternal Locker™</b> is a secure digital vault that helps families preserve sensitive documents, instructions, and memories. When life's uncertainties arise, your loved ones will have access to everything they need.
            </p>
            <ul className="space-y-4 text-left pt-4">
                <li className="flex items-start">
                    <Shield className="w-6 h-6 mr-3 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                        <strong className="block text-primary-dark">Encrypted Data Protection:</strong>
                        <span className="text-sm text-primary-dark">Your data is encrypted and locked so only you and your chosen nominees can ever access it.</span>
                    </div>
                </li>
                <li className="flex items-start">
                    <Briefcase className="w-6 h-6 mr-3 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                        <strong className="block text-primary-dark">Automated Nominee Access:</strong>
                        <span className="text-sm text-primary-dark">Set nominees once. If you become inactive, they automatically gain secure access to your entire locker without complexity or delays.</span>
                    </div>
                </li>
                <li className="flex items-start">
                    <Users className="w-6 h-6 mr-3 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                        <strong className="block text-primary-dark">Organize Everything in One Place:</strong>
                        <span className="text-sm text-primary-dark">Documents, IDs, financial info, property deeds, digital accounts, medical wishes, and more - all organized and accessible.</span>
                    </div>
                </li>
                <li className="flex items-start">
                    <Shield className="w-6 h-6 mr-3 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                        <strong className="block text-primary-dark">Full Audit Trail & Transparency:</strong>
                        <span className="text-sm text-primary-dark">All nominee logins and access events are logged for your security and peace of mind.</span>
                    </div>
                </li>
                <li className="flex items-start">
                    <Briefcase className="w-6 h-6 mr-3 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                        <strong className="block text-primary-dark">Simple, Transparent Pricing:</strong>
                        <span className="text-sm text-primary-dark">No hidden fees. Clear plans that fit your needs. 7-day money-back guarantee on new subscriptions.</span>
                    </div>
                </li>
            </ul>
        </div>
    );
}